import { render, staticRenderFns } from "./BlogPressReleases.vue?vue&type=template&id=67cce47a"
import script from "./BlogPressReleases.vue?vue&type=script&lang=js"
export * from "./BlogPressReleases.vue?vue&type=script&lang=js"
import style0 from "./BlogPressReleases.vue?vue&type=style&index=0&id=67cce47a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports